module.exports = __webpack_public_path__ + "img/ic_nav_reset.8d830958.svg";